if (typeof VideoPresentation !== 'function') {
  class VideoPresentation extends HTMLElement {
  constructor() {
    super();
    var that = this;
    var swiperDom_1 = this.querySelector(".indexvideoPresentation");
    var swiperDom_2 = this.querySelector(".indexvideoPresentation2");
    var closeBtn = this.querySelector(".video_mid_cha");

    closeBtn.addEventListener("click", this.handleClose.bind(this));

    this.swiper1 = new Swiper(swiperDom_1, {
      loop: true,
      speed: 12000, //匀速时间
      preventClicksPropagation: false,
      slidesPerView: "auto",
      freeMode: true,
      freeModeMomentum: false,
      grabCursor: true,
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      breakpoints: {
        280: {
          slidesPerView: "auto",
          spaceBetween: 6,
        },
        769: {
          //当屏幕宽度大于等于768

          slidesPerView: "auto",
          spaceBetween: 16,
        },
        1300: {
          //当屏幕宽度大于等于768
          slidesPerView: "auto",
          spaceBetween: 18,
        },
      },
    });

    if (swiperDom_2.querySelectorAll(".swiper-slide").length > 0) {
      this.swiper2 = new Swiper(swiperDom_2, {
        loop: true,
        speed: 14000, //匀速时间
        slidesPerView: "auto",
        freeMode: true,
        freeModeMomentum: false,
        grabCursor: true,
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        breakpoints: {
          280: {
            //当屏幕宽度大于等于768
            slidesPerView: "auto",
            spaceBetween: 6,
          },
          769: {
            //当屏幕宽度大于等于768
            slidesPerView: "auto",
            spaceBetween: 16,
          },
          1300: {
            //当屏幕宽度大于等于768
            slidesPerView: "auto",
            spaceBetween: 16,
          },
        },
      });
    }

    var videoBtns = this.querySelectorAll(".boxVideo_bottomBox_videoSvg");

    videoBtns.forEach(function (videoBtn) {
      console.log("videoBtn", videoBtn);
      videoBtn.addEventListener(
        "click",
        that.boxVideoPaly.bind(that, videoBtn)
      );
    });
  }

  boxVideoPaly(e) {
    console.log("VideoPresentation e", e);
    var parentDom = e.closest("video-presentation");
    $("body").addClass("overflowHtml");
    $(parentDom).find(".bg-color").show();
    $(parentDom).find(".videos_video_fixed").show();
    this.swiper1.autoplay.stop();
    this.swiper2 && this.swiper2.autoplay.stop();
    var viveoPC = $(e).parent().find(".boxVideo_bottomBox_videoUrl").html();
    // https://www.youtube.com/embed/xjDuYfx6jfU?si=DHoxcpiaauPdnKUB
    if (viveoPC.indexOf("youtube") > -1 && viveoPC.indexOf("embed") === -1) {
      var url = new URL(viveoPC);
      var videoId = url.searchParams.get("v");
      viveoPC =
        "https://www.youtube.com/embed/" +
        videoId +
        "?autoplay=1&rel=0&showinfo=0&modestbranding=1&controls=0&disablekb=1&fs=0&iv_load_policy=3&loop=1&playlist=" +
        videoId;
    }
    $(".videos_video_fixed")
      .children(".responsive-videos")
      .attr("src", viveoPC.trim());
  }

  handleClose(e) {
    console.log("handleClose", e);
    $(".bg-color").hide();
    $(".videos_video_fixed").hide();
    $("body").removeClass("overflowHtml");
    $(".videos_video_fixed").children(".responsive-videos").attr("src", "");

    this.swiper1.autoplay.start();
    this.swiper2 && this.swiper2.autoplay.start();
  }
}

customElements.define("video-presentation", VideoPresentation);

}

class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
        this.container = this.querySelector('.infinite-scroll-container');
        this.images = this.querySelector('.infinite-scroll-images');
        this.cloneImages = this.images.innerHTML;
        this.images.innerHTML += this.cloneImages;
        this.speed = Number(this.getAttribute('data-speed'))
        if (!this.speed || NaN === this.speed) {
            this.speed = 1;
        }

        this.posX = 0;
        this.startX = 0;
        this.isDragging = false;

        this.scrollImagesHandle = null;

        this.container.addEventListener('mousedown', this.handleMouseDown.bind(this));
        this.container.addEventListener('mousemove', this.handleMouseMove.bind(this));
        this.container.addEventListener('mouseup', this.handleMouseUp.bind(this));
        this.container.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
        this.container.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
        this.container.addEventListener('touchstart', this.handleTouchstart.bind(this));
        this.container.addEventListener('touchmove', this.handleTouchmove.bind(this));
        this.container.addEventListener('touchend', this.handleMouseUp.bind(this));
        this.scrollImagesHandle = requestAnimationFrame(this.scrollImages.bind(this));

    }
    scrollImages() {
        this.posX -= this.speed;
        if (this.posX <= -this.images.scrollWidth / 2) {
            this.posX = this.posX + this.images.scrollWidth / 2;
        } else if (this.posX > 0) {
            this.posX = 0;
        }
        this.images.style.transform = `translateX(${this.posX}px)`;
        this.scrollImagesHandle = requestAnimationFrame(this.scrollImages.bind(this));
    }

    stopScrolling() {
        cancelAnimationFrame(this.scrollImagesHandle);
    }

    handleTouchstart(event) {
        this.isDragging = true;
        this.startX = event.touches[0].clientX - this.posX;
        this.container.style.cursor = 'grabbing';
        this.stopScrolling();
    }
    handleTouchmove(event) {
        if (this.isDragging) {
            this.posX = event.touches[0].clientX - this.startX;
            this.images.style.transform = `translateX(${this.posX}px)`;
        }
    }
    handleMouseDown(event) {
        this.isDragging = true;
        this.startX = event.clientX - this.posX;
        this.container.style.cursor = 'grabbing';
        this.stopScrolling();
    }

    handleMouseMove(event) {
        if (this.isDragging) {
            this.posX = event.clientX - this.startX;
            this.images.style.transform = `translateX(${this.posX}px)`;
        }
    }

    handleMouseUp() {
        this.isDragging = false;
        this.container.style.cursor = 'grab';
        this.scrollImagesHandle = requestAnimationFrame(this.scrollImages.bind(this));
    }

    handleMouseLeave() {
        if (this.isDragging) {
            this.isDragging = false;
            this.container.style.cursor = 'grab';
            this.scrollImagesHandle = requestAnimationFrame(this.scrollImages.bind(this));
        }
    }

    handleMouseEnter() {
        this.container.style.cursor = 'grab';
    }

}
customElements.define('infinite-scroll', InfiniteScroll);

class VideoPopup extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.videoBtns = this.querySelectorAll('.boxVideo_bottomBox_videoSvg');
    this.bgColor = document.querySelector('.video-popup > .bg-color');
    this.videoFixed = document.querySelector('.video-popup > .videos_video_fixed');
    this.closeBtn = document.querySelector('.video-popup .video_mid_cha');
    this.closeBtn.addEventListener('click', this.handleClose.bind(this));
    this.addEventListener('click', this.handlePlay.bind(this));
  }
  handlePlay(e) {
    var viveoPC = this.getAttribute('data-url');
    // https://www.youtube.com/embed/xjDuYfx6jfU?si=DHoxcpiaauPdnKUB
    if (viveoPC.indexOf("youtube") > -1 && viveoPC.indexOf("embed") === -1) {
      var url = new URL(viveoPC);
      var videoId = url.searchParams.get("v");
      viveoPC =
        "https://www.youtube.com/embed/" +
        videoId +
        "?autoplay=1&mute=1&rel=0&showinfo=0&modestbranding=1&controls=0&disablekb=1&fs=0&iv_load_policy=3&loop=1&playlist=" +
        videoId;
    }
    this.bgColor.style.display = 'block';
    this.videoFixed.style.display = 'block';
    this.videoFixed.querySelector('.responsive-videos').src = viveoPC.trim();
    document.querySelector('body').classList.add('overflowHtml');
  }
  handleClose() {
    this.bgColor.style.display = 'none';
    this.videoFixed.style.display = 'none';
    this.videoFixed.querySelector('.responsive-videos').src = '';
    document.querySelector('body').classList.remove('overflowHtml');
  }
}
customElements.define('video-popup', VideoPopup);

// const container = document.getElementById('container');
//         const images = document.getElementById('images');
//         let cloneImages = images.innerHTML;
//         images.innerHTML += cloneImages;

//         let posX = 0;
//         let startX = 0;
//         let isDragging = false;

//         function scrollImages() {
//             posX -= 1;
//             if (posX <= -images.scrollWidth / 2) {
//                 posX = posX + images.scrollWidth / 2;
//             }
//             images.style.transform = `translateX(${posX}px)`;
//             scrollImagesHandle = requestAnimationFrame(scrollImages);
//         }

//         function stopScrolling() {
//             cancelAnimationFrame(scrollImagesHandle);
//         }

//         container.addEventListener('mousedown', (event) => {
//             isDragging = true;
//             startX = event.clientX - posX;
//             container.style.cursor = 'grabbing';
//             stopScrolling();
//         });

//         container.addEventListener('mousemove', (event) => {
//             if (isDragging) {
//                 posX = event.clientX - startX;
//                 images.style.transform = `translateX(${posX}px)`;
//             }
//         });

//         container.addEventListener('mouseup', () => {
//             isDragging = false;
//             container.style.cursor = 'grab';
//             scrollImagesHandle = requestAnimationFrame(scrollImages);
//         });
//         // 手机端拖拽
//         container.addEventListener('touchstart', (event) => {
//             isDragging = true;
//             startX = event.touches[0].clientX - posX;
//             container.style.cursor = 'grabbing';
//             stopScrolling();
//         })
//         container.addEventListener('touchmove', (event) => {
//             if (isDragging) {
//                 posX = event.touches[0].clientX - startX;
//                 images.style.transform = `translateX(${posX}px)`;
//             }
//         })
//         container.addEventListener('touchend', () => {
//             isDragging = false;
//             container.style.cursor = 'grab';
//             scrollImagesHandle = requestAnimationFrame(scrollImages);
//         })

//         container.addEventListener('mouseleave', () => {
//             if (isDragging) {
//                 isDragging = false;
//                 container.style.cursor = 'grab';
//                 scrollImagesHandle = requestAnimationFrame(scrollImages);
//             }
//         });

//         container.addEventListener('mouseenter', () => {
//             container.style.cursor = 'grab';
//         });

//         window.onload = () => {
//             scrollImagesHandle = requestAnimationFrame(scrollImages);
//         };